<template>
  <div style="height: 100%" :class="darkModeEnabled ? 'dark' : ''" v-if="simpleMeetingsVmaatu">

    <!-- Meeting -->
    <el-container class="meeting-room" id="meeting-room" style="height: 100%">
      <el-container style="height: 100%">
        <el-main class="main-content" v-show="!KIOSK_MODE || CALL_IN_PROGRESS">
          <el-row style="margin-bottom: 1em;height: 100%" v-loading="internetDisconnected" element-loading-custom-class="no-internet" element-loading-text="You lost your internet connection. Trying to reconnect." id="meeting">
            <el-col :span="24" class="remote-videos-wrapper" v-loading="(!allParticipants || allParticipants.length < 1) && mediaMode != 'sendonly'" :element-loading-text="waitingMsg ? waitingMsg : waitForOthersMsg" element-loading-background="#c3c3c36e" element-loading-fullscreen="false" style="height: 100%;">

              <!-- Meeting Title  -->
              <!-- Added v-if to hide when side panel is opened on mobile -->
              <div class="d-flex justify-content-between">

                <span id="recording-text" v-show="recording">
                  <font-awesome-icon icon="circle" class="blink" style="color: red; width: 0.8em" /><span :style="{ color: darkModeEnabled ? 'white' : 'black' }">REC</span>
                </span>

              </div>

              <!--Grid layout -->
              <div id="remoteHolder" :class="[getVideoLayout(), 'videos' + allParticipants.length]" class="grid" v-if="videoLayout == 'grid'" v-touch:swipe.left="goToNextPage" v-touch:swipe.right="goToPreviousPage">

                <div :class="[video.main && 'main']" :ref="'remoteVideoDiv-' + video.id" v-for="video in paginatedParticipants" :key="video.id" :id="video.id" style="position: relative;display: flex;
                justify-content: center;" :style="{ height: videoHeight, width: videoWidth }" class="remote-participant" v-loading="(!video.streams.videoHighRes && !video.streams.videoLowRes)">
                  <!-- Added postion:relative to remove grey space around video -->
                  <div style="position: absolute;top: 50%;transform: translateY(-50%);outline: 2px solid transparent;transition: outline 1s ease-in-out;" class="video-wrapper video-div" v-if="videoLayout == 'grid' || (videoLayout == 'active-presence' && video.main)" :style="{ aspectRatio: simpleMeetingsVmaatu.isMobile() && allParticipants.length > 3 ? '1' : '', background: (!AUDIO_ONLY && !video.videoMuted && !isMobileVideo(video)) ? 'none' : '#606266', height: (allParticipants.length < 3 || landscapeMode) ? '100%' : '' }" :class="{ 'active-speaker': video.speaking }" v-loading="isMyVideo(video.id)">
                    <pinch-zoom v-if="pinchZoomEnabled">
                      <video :srcObject.prop="video.streams.videoHighRes || video.streams.videoLowRes" autoplay playsinline muted v-if="!AUDIO_ONLY && !video.videoMuted" :id="'vid_' + video.id" :class="{ 'my-video': isMyVideo(video.id), 'desktop-video': !isMobileVideo(video), 'mobile-video': isMobileVideo(video) && allParticipants.length >= 3 }" :style="{ width: simpleMeetingsVmaatu.isMobile() && allParticipants.length > 3 ? 'unset' : '', height: isMobileVideo(video) ? '100%' : '' }"></video>
                    </pinch-zoom>

                    <video :srcObject.prop="video.streams.videoHighRes || video.streams.videoLowRes" autoplay playsinline muted v-if="!AUDIO_ONLY && !video.videoMuted && !pinchZoomEnabled" :id="'vid_' + video.id" :class="{ 'my-video': isMyVideo(video.id), 'desktop-video': !isMobileVideo(video), 'mobile-video': isMobileVideo(video) && allParticipants.length >= 3 }" :style="{ width: simpleMeetingsVmaatu.isMobile() && allParticipants.length > 3 ? 'unset' : '', height: allParticipants.length > 2 ? '100%' : '' }"></video>

                    <div v-if="AUDIO_ONLY" style="position:absolute;">
                      <font-awesome-icon :icon="'user'" :style="userAvatarClass" />
                    </div>

                    <span class="participant-name" :style="{ bottom: landscapeMode ? '15%' : '' }"> {{ getParticipantName(video.id) }}
                      <font-awesome-icon :icon="video.audioMuted ? 'microphone-slash' : 'microphone'" :style="{ color: video.audioMuted ? '#f56c6c' : '#67c23a' }" />
                    </span>
                  </div>

                  <el-avatar icon="el-icon-user-solid" size="large" v-if="video.videoMuted" class="participant-video-avatar" :class="{ 'participant-video-avatar-mobile': simpleMeetingsVmaatu.isMobile() }"></el-avatar>

                </div>

                <div v-if="mediaMode == 'sendonly'" style="color: #1e95fa;font-size: 20px;position: absolute;top: 18em;">
                  {{ $t("message.You are presenting") }}
                </div>
              </div>

              <div class="remote-alert" v-if="remoteAlert">
                <div style="margin-top: 2rem;">
                  <i class="fa fa-exclamation-triangle" style="color: red;padding: 0.5rem;font-size: 1.5em;text-shadow: 0px 0px 5px black"></i>
                  <span style="color: #fffdfd;">{{ $t("message.OBJECT DETECTED") }}</span>
                </div>
              </div>

              <!-- Audio tags -->
              <div v-for="participant in allParticipants" :key="participant.id">
                <audio :srcObject.prop="participant.streams.audio" autoplay playsinline v-if="participant.streams.audio" ref="remoteAudios">
                </audio>
              </div>

              <!-- Pagination buttons-->
              <el-button type="info" @click="goToPreviousPage" circle style="position: absolute;left: 1em;top: 50%;transform: translateY(-50%);z-index: 2003" v-if="pageNumber > 1 && videoLayout == 'grid'">
                <i class="el-icon-arrow-left"></i>
              </el-button>

              <el-button type="info" @click="goToNextPage" circle style="position: absolute;inset-inline-end: 1em;top: 50%;transform: translateY(-50%);z-index: 2003" v-if="pageNumber < gridLayout.pageSize && videoLayout == 'grid'">
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </el-col>
            <!-- Local video for mobile-->
            <el-row v-if="localParticipant" style="justify-content: start;margin-bottom: 0.5em;position: absolute;bottom: -0.5em;" :style="{ display: hideControls ? 'none' : 'flex' }">
              <div class="video-wrapper video-div my-video-div" style="position: relative;box-shadow: 0 0 20px black;bottom:0.6rem;left: 0.6rem" :style="{ background: (!AUDIO_ONLY && !simpleMeetingsVmaatu.webrtcManager.videoMuted && !isMobileVideo(localParticipant)) ? 'none' : '#606266', width: landscapeMode ? '13vw' : '' }" :class="{ 'active-speaker': localParticipant.speaking, 'mobile-video-div': isMobileVideo(localParticipant) }">
                <video :srcObject.prop="localParticipant.streams.videoHighRes || localParticipant.streams.videoLowRes" autoplay playsinline muted v-if="!AUDIO_ONLY && !simpleMeetingsVmaatu.webrtcManager.videoMuted" :id="'vid_' + localParticipant.id" :class="{ 'my-video': isMyVideo(localParticipant.id), 'desktop-video': !isMobileVideo(localParticipant), 'mobile-video': isMobileVideo(localParticipant) }"></video>

                <el-avatar icon="el-icon-user-solid" size="large" v-if="simpleMeetingsVmaatu.webrtcManager.videoMuted" class="participant-video-avatar" :class="{ 'participant-video-avatar-mobile': simpleMeetingsVmaatu.isMobile() }"></el-avatar>
              </div>
            </el-row>
          </el-row>
          <!--Contrls-->
          <el-row v-if="simpleMeetingsVmaatu && controlsEnabled() && !hideControls" style="position: absolute;bottom: 0.6rem;inset-inline-end: 1rem;z-index: 2001;display: flex;justify-content: end;" :class="{ 'landscape-controls': landscapeMode }">
            <div class="d-flex justify-content-center">
              <!-- Media controls buttons for mobile -->
              <div>
                <span class="d-flex justify-content-center">

                  <el-tooltip :disabled="simpleMeetingsVmaatu.isMobile()" v-if="!VIDEO_ONLY && mediaMode != 'recvonly'" class="item" :effect="darkModeEnabled ? 'light' : 'dark'" :content="audioMuted() ? 'Unmute' : 'Mute'" placement="top" :open-delay="1500">
                    <el-button style="height: 3em; width: 3em;" @click="toggleMuteAudio" circle :class="audioMuted() ? 'text-danger' : ''">
                      <font-awesome-icon :icon="!audioMuted() ? 'microphone' : 'microphone-slash'" />
                    </el-button>
                  </el-tooltip>

                  <el-tooltip :disabled="simpleMeetingsVmaatu.isMobile()" v-if="!AUDIO_ONLY && mediaMode != 'recvonly'" class="item" :effect="darkModeEnabled ? 'light' : 'dark'" :content="videoMuted() ? 'Cam on' : 'Cam off'" placement="top" :open-delay="1500">
                    <el-button style="height: 3em; width: 3em;" :class="videoMuted() ? 'text-danger' : ''" @click="toggleMuteVideo" circle>
                      <font-awesome-icon :icon="videoMuted() ? 'video-slash' : 'video'" />
                    </el-button>
                  </el-tooltip>

                  <el-tooltip style="height: 3em; width: 3em;" :disabled="simpleMeetingsVmaatu.isMobile()" class="item" :effect="darkModeEnabled ? 'light' : 'dark'" :content="recording ? 'Stop recording' : 'Start recording'" placement="top" :open-delay="1500" v-if="recordingFeatureEnabled()">
                    <el-button circle :disabled="recordingDisabled()" @click="toggleRecording" class="text-danger">
                      <font-awesome-icon :icon="['fas', recording ? 'square' : 'circle']" />
                    </el-button>
                  </el-tooltip>

                  <el-tooltip style="height: 3em; width: 3em;" :disabled="simpleMeetingsVmaatu.isMobile()" class="item" :effect="darkModeEnabled ? 'light' : 'dark'" content="Toggle Camera" placement="top" :open-delay="1500" v-if="simpleMeetingsVmaatu.isMobile() && !internetDisconnected">
                    <el-button @click="toggleCamera" circle>
                      <!-- <font-awesome-icon icon="sync-alt" /> -->
                      <img style="width: 1.35em;" alt src="@/assets/img/simplemeetings/camera-switch.png" />
                    </el-button>
                  </el-tooltip>

                  <el-tooltip style="height: 3em; width: 3em;" :disabled="simpleMeetingsVmaatu.isMobile()" class="item" :effect="darkModeEnabled ? 'light' : 'dark'" content="Refresh" placement="top" :open-delay="1500" v-if="simpleMeetingsVmaatu.isMobile() && !internetDisconnected">
                    <el-button @click="refresh" circle class="refresh-button" style="position: fixed;top: 9.8%;right: 2%;">
                      <font-awesome-icon icon="redo-alt" />
                    </el-button>
                  </el-tooltip>
                </span>
              </div>
            </div>
          </el-row>

        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import SimpleMeetingsVmaatu from "@teslontechnologies/simplemeetings-core-vmaatu";
import "offline-js";

export default {
  props: [
    "query",
    "remoteAlert",
    "pinchZoomEnabled",
    "waitingMsg",
    "hideControls",
  ],
  data() {
    return {
      waitForOthersMsg: this.$t("message.Please wait while others join"),
      darkModeEnabled: true,
      userJoinedNotification: null,
      userExitedNotification: null,
      userPinned: false,
      internetDisconnected: false,
      optimalVideoSubscription: {
        noOfParticipants: 0,
        videoLayout: "grid",
        pageNumber: 0,
      },
      landscapeMode: false,
      showActionsForMobile: false,
      hasScreenShare: false,
      mainParticipantsForActivePresence: [],
      videoResolutionType: "",
      currentResolution: "videoHighRes",
      localParticipant: null,
      allParticipants: [],
      participantName: "",
      participantId: "",
      pageNumber: 1,
      screenWidth: window.innerWidth,
      simpleMeetingsVmaatu: null,
      isMobile: false,
      layout: {
        presenting: false,
        videoSpeaker: true,
        videoMosaic: false,
        fullscreen: false,
      },
      recording: false,
      remoteLoading: true,
      localLoading: true,
      notificationHandle: {
        close() { },
      },
      videoLayout: "grid",
      KIOSK_MODE: false,
      CALL_IN_PROGRESS: false,
      showCameraToggleButton: false,
      remoteMediaContainerSelector: ".remote-videos",
      localMediaContainerSelector: "#localHolder",
      HAS_CAMERA_ACCESS: false,
      videoDevices: [],
      audioDevices: [],
      selectedVideoDevice: "",
      selectedAudioDevice: "",
      AUDIO_ONLY: false,
      VIDEO_ONLY: false,
      userAvatarClass: "",
      mediaMode: null,
      speakerMuted: false,
      room: {},
      modelValidations: {
        name: {
          required: true,
        },
        email: {
          email: true,
          required: true,
        },
      },
      participantUrl: "",
      vmaatuAudioMuted: false,
      vmaatuVideoMuted: false,
    };
  },
  mounted: async function () {
    let that = this;

    /* Commented this code as we are handling offline state from parent */
    // Offline.on("down", () => {
    //   this.internetDisconnected = true;
    // });

    if (this.query && this.query.user_name) {
      this.participantName = this.query.user_name;
    }

    if (this.query && this.query.user_id) {
      this.participantId = this.query.user_id;
    }

    //await this.changeMedia();
    this.getMediaDevices(true);
    if (
      window &&
      window.screen &&
      window.screen.orientation &&
      window.screen.orientation.type &&
      (window.screen.orientation.type == "landscape-primary" ||
        window.screen.orientation.type == "landscape-secondary")
    ) {
      this.landscapeMode = true;
    } else {
      this.landscapeMode = false;
    }

    window.onorientationchange = () => {
      if (
        window.screen.orientation.type == "landscape-primary" ||
        window.screen.orientation.type == "landscape-secondary"
      ) {
        this.landscapeMode = true;
      } else {
        this.landscapeMode = false;
      }
    };
  },
  computed: {
    videoEffectsApplied() {
      if (
        this.simpleMeetingsVmaatu.webrtcManager &&
        (this.simpleMeetingsVmaatu.webrtcManager.videoBackgroundBlurred ||
          this.simpleMeetingsVmaatu.webrtcManager.videoBackground)
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasMyScreen() {
      return (
        this.simpleMeetingsVmaatu &&
        this.simpleMeetingsVmaatu.webrtcManager &&
        this.simpleMeetingsVmaatu.webrtcManager.localScreenStream
      );
    },
    myId() {
      if (this.simpleMeetingsVmaatu && this.simpleMeetingsVmaatu.userManager) {
        return this.simpleMeetingsVmaatu.userManager.id;
      }
    },
    myRole() {
      if (this.simpleMeetingsVmaatu && this.simpleMeetingsVmaatu.userManager) {
        return this.simpleMeetingsVmaatu.userManager.role;
      }
    },
    remoteParticipants() {
      return this.simpleMeetingsVmaatu &&
        this.simpleMeetingsVmaatu.participantManager
        ? this.simpleMeetingsVmaatu.participantManager.participants
        : [];
    },

    paginatedParticipants() {
      let startIndex =
        this.gridLayout.row * this.gridLayout.col * (this.pageNumber - 1);

      let paginatedParticipants = this.allParticipants.slice(
        startIndex,
        this.gridLayout.row * this.gridLayout.col * this.pageNumber
      );
      return paginatedParticipants;
    },
    paginatedparticipantsExceptMe() {
      if (
        this.paginatedParticipants &&
        this.paginatedParticipants.length &&
        this.myId
      ) {
        this.paginatedParticipants.forEach((p) => {
          console.log(p.name + " " + Object.keys(p.streams));
        });
        return this.paginatedParticipants.filter((participant) => {
          return participant.id != this.myId;
        });
      } else {
        return [];
      }
    },
    videoHeight() {
      if (this.videoLayout == "grid") {
        return 100 / this.gridLayout.row + "%";
      } else {
        return "calc(100% - 7em)";
      }
    },
    videoWidth() {
      if (this.videoLayout == "grid") {
        return 100 / this.gridLayout.col + "%";
      } else {
        return "100%";
      }
    },
    pageSizeForMosaic() {
      if (this.screenWidth > 1439) {
        return 6;
      } else if (this.screenWidth > 1046) {
        return 5;
      } else if (this.screenWidth > 841) {
        return 4;
      } else if (this.screenWidth > 623) {
        return 3;
      } else {
        return 2;
      }
    },

    gridLayout() {
      let mobileWidth = 576;

      if (this.screenWidth <= mobileWidth) {
        if (this.allParticipants.length == 1) {
          return {
            row: 1,
            col: 1,
            pageSize: 1,
          };
        } else if (this.allParticipants.length == 2) {
          return {
            row: 2,
            col: 1,
            pageSize: 1,
          };
        } else if (this.allParticipants.length == 3) {
          return {
            row: 3,
            col: 1,
            pageSize: 1,
          };
        } else if (this.allParticipants.length == 4) {
          return {
            row: 2,
            col: 2,
            pageSize: 1,
          };
        } else if (this.allParticipants.length <= 6) {
          return {
            row: 3,
            col: 2,
            pageSize: 1,
          };
        } else {
          return {
            row: 3,
            col: 2,
            pageSize: Math.ceil(this.allParticipants.length / 6),
          };
        }
      } else if (this.screenWidth > mobileWidth) {
        if (this.allParticipants.length == 1) {
          return {
            row: 1,
            col: 1,
            pageSize: 1,
          };
        } else if (this.allParticipants.length == 2) {
          return {
            row: 1,
            col: 2,
            pageSize: 1,
          };
        } else if (this.allParticipants.length <= 4) {
          return {
            row: 2,
            col: 2,
            pageSize: 1,
          };
        } else if (this.allParticipants.length <= 6) {
          return {
            row: 2,
            col: 3,
            pageSize: 1,
          };
        } else if (this.allParticipants.length <= 9) {
          return {
            row: 3,
            col: 3,
            pageSize: 1,
          };
        } else {
          return {
            row: 3,
            col: 3,
            pageSize: Math.ceil(this.allParticipants.length / 9),
          };
        }
      }
    },
  },

  methods: {
    toggleDarkMode() {
      let that = this;
      if (this.simpleMeetingsVmaatu.isMobile()) {
        this.showActionsForMobile = false;
        setTimeout(() => {
          that.darkModeEnabled = !that.darkModeEnabled;
          document.body.classList.toggle("dark");
        }, 300);
      } else {
        this.darkModeEnabled = !this.darkModeEnabled;
        document.body.classList.toggle("dark");
      }
    },
    destroy() {
      try {
        if (this.simpleMeetingsVmaatu) {
          this.simpleMeetingsVmaatu.destroy();
          this.simpleMeetingsVmaatu = null;
        }
      } catch (e) {
        console.log(e);
      }
    },
    pinParticpant() {
      this.userPinned = !this.userPinned;
    },
    init() {
      this.initSimplemeetings();
    },
    async initSimplemeetings() {
      let that = this;
      if (this.simpleMeetingsVmaatu) {
        //For rejoin on network reconnect, disconnect old socket connection
        if (
          this.simpleMeetingsVmaatu.userManager &&
          this.simpleMeetingsVmaatu.userManager.id
        ) {
          this.simpleMeetingsVmaatu.webrtcManager.disconnectStaleParticipant(
            this.simpleMeetingsVmaatu.userManager.id
          );
        }

        this.simpleMeetingsVmaatu.destroy();
        this.simpleMeetingsVmaatu = null;
      }

      if (
        this.$route.query.kiosk_mode &&
        this.$route.query.kiosk_mode == "true"
      ) {
        this.KIOSK_MODE = true;
      }
      let socketServerURL;
      console.log("window.config.UC_SERVER_URL", window.config.UC_SERVER_URL);
      // eslint-disable-next-line no-undef
      if (typeof window.config == "undefined") {
        socketServerURL = this.baseUrl;
      } else {
        // eslint-disable-next-line no-undef
        socketServerURL = window.config.UC_SERVER_URL;
      }

      console.log("BaseUrl -- ", this.baseUrl);

      let options = Object.assign(this.query, {
        frame_rate: 26,
        log_level: "debug",
        facing_mode: "user",
      });

      // options.always_sfu = "true";

      console.log("options", options);
      console.log("socketServerURL", socketServerURL);

      let simpleMeetingsVmaatu = new SimpleMeetingsVmaatu(
        socketServerURL,
        options
      );

      this.simpleMeetingsVmaatu = simpleMeetingsVmaatu;
      window.simpleMeetingsVmaatu = simpleMeetingsVmaatu;

      await this.simpleMeetingsVmaatu.init();
      //await this.simpleMeetingsVmaatu.webrtcManager.setFacingMode("user");

      this.updateParticipants();

      this.AUDIO_ONLY = !this.simpleMeetingsVmaatu.webrtcManager.useVideo;
      this.VIDEO_ONLY = !this.simpleMeetingsVmaatu.webrtcManager.useAudio;
      this.mediaMode = this.query.media_mode;

      if (this.mediaMode == "recvonly") {
        this.speakerMuted = true;
      }

      this.simpleMeetingsVmaatu.eventEmitter.on("socketReconnected", () => {
        this.internetDisconnected = false;
        this.initSimplemeetings();
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("localVideo", (stream) => {
        this.updateParticipants();
      });

      // added this to fix mic getting unmuted after reinitialize
      this.simpleMeetingsVmaatu.eventEmitter.on("enumerateMediaDevicesCompleted", () => {

        if (this.vmaatuAudioMuted) {
          setTimeout(() => {
            this.toggleMuteAudio();
          }, 2000);
        }

        if (this.vmaatuVideoMuted) {
          this.toggleMuteVideo();
        }
      });


      this.simpleMeetingsVmaatu.eventEmitter.on(
        "remoteVideo",
        (id, stream, streamType) => {
          let participant = this.allParticipants.find(
            (_participant) => _participant.id == id
          );

          if (!participant.waitingToConnect) {
            participant.waitingToConnect = {};
          }
          participant.waitingToConnect[streamType] = false;
          this.updateParticipants();
          setTimeout(() => {
            this.$forceUpdate();
          }, 2000);
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "remoteVideoRemoved",
        (id, streamType) => {
          let participant = this.allParticipants.find(
            (_participant) => _participant.id == id
          );

          participant.waitingToDisconnect[streamType] = false;

          this.updateParticipants();
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "newParticipant",
        (participant) => {
          this.updateParticipants();
          this.simpleMeetingsVmaatu.webrtcManager.connectToSFUParticipant(
            participant.id,
            "audio"
          );

          /*           if (this.userJoinedNotification) {
            this.userJoinedNotification.close();
          }

          this.userJoinedNotification = this.$notify({
            message: this.getParticipantName(participant.id) + " has joined.",
            position: this.screenWidth <= 576 ? "top-left" : "bottom-left",
            duration: 3000,
            customClass: "user-joined-exited",
            showClose: false,
            iconClass: "far fa-user",
          }); */
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on("localScreen", (stream) => {
        this.remoteLoading = true;
        this.hasScreenShare = true;

        this.updateParticipants();

        this.mainParticipantsForActivePresence = [
          this.allParticipants.find((participant) => {
            return participant.id == that.myId;
          }),
        ];

        //   this.allParticipants.unshift({
        //     id: "10",
        //     stream: null,
        //     main: true,
        //     audioMuted: false,
        //     videoMuted: false,
        //     participantName: "Karthik D",
        //     isPresenter: true,
        //   });
        console.log("calling toogle layout for local screen", this.videoLayout);

        if (this.videoLayout == "grid") {
          this.toggleVideoLayout(false);
        }
        setTimeout(() => {
          this.remoteLoading = false;
        }, 2000);
      });

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "localScreenRemoved",
        (stream) => {
          console.log("calling toogle layout for local screen removed");

          this.hasScreenShare = false;

          if (this.videoLayout == "active-presence") {
            this.toggleVideoLayout();
          }
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on("remoteScreen", (id) => {
        console.log("got remote stream", id);
        this.remoteLoading = true;
        this.hasScreenShare = true;

        this.updateParticipants();

        if (this.hasMyScreen) {
          console.log("stopping my screen share");
          this.simpleMeetingsVmaatu.webrtcManager.stopScreenShare();
        }

        this.mainParticipantsForActivePresence = [
          this.allParticipants.find((participant) => {
            return participant.id == id;
          }),
        ];

        //   this.allParticipants.unshift({
        //     id: "10",
        //     stream: null,
        //     main: true,
        //     audioMuted: false,
        //     videoMuted: false,
        //     participantName: "Karthik D",
        //     isPresenter: true,
        //   });
        console.log("calling toogle layout for local screen");

        if (this.videoLayout == "grid") {
          this.toggleVideoLayout(false);
        }
        setTimeout(() => {
          this.remoteLoading = false;
        }, 2000);
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("remoteScreenRemoved", (id) => {
        console.log("calling toogle layout for local remote screen removed");
        // Toggle video layout only when no one is sharing screen
        let sharingScreen = false;
        for (let participant of this.allParticipants) {
          if (participant.sharingScreen == true) {
            sharingScreen = true;
            break;
          }
        }
        if (!this.hasMyScreen && !sharingScreen) {
          this.hasScreenShare = false;
          if (this.videoLayout == "active-presence") {
            this.toggleVideoLayout();
          }
        }
      });
      this.simpleMeetingsVmaatu.eventEmitter.on("remoteAudio", (id, stream) => {
        this.updateParticipants();
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("participantRemoved", (id) => {
        /*         if (this.userExitedNotification) {
          this.userExitedNotification.close();
        }

        this.userExitedNotification = this.$notify({
          message: this.getParticipantName(id) + " has exited.",
          position: this.screenWidth <= 576 ? "top-left" : "bottom-left",
          duration: 3000,
          customClass: "user-joined-exited",
          showClose: false,
          iconClass: "far fa-user",
        }); */

        this.updateParticipants();

        //If main participant leaves in active presence mode, selecting first participant as the main participant
        let wasMainParticipant = this.mainParticipantsForActivePresence.find(
          (participant) => {
            return participant.id == id;
          }
        );

        if (wasMainParticipant) {
          this.setAsMainVideo(this.allParticipants[0].id);
        }
        // Toggle video layout only when no one is sharing screen
        let sharingScreen = false;
        for (let participant of this.allParticipants) {
          if (participant.sharingScreen == true) {
            sharingScreen = true;
            break;
          }
        }
        if (
          this.allParticipants.length <= 2 &&
          this.videoLayout == "active-presence" &&
          !this.hasMyScreen &&
          !sharingScreen
        ) {
          this.toggleVideoLayout(true);
        }
      });

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "mediaDeviceError",
        (errMessage) => {
          if (errMessage && errMessage.indexOf("Permission denied") > -1) {
            console.log("Media device permission denied");
            that.$notify.error({
              title: this.$t("message.Permission denied"),
              message: this.$t("message.Permission to camera/microphone was denied Please grant permissions in your browser setting or contact administrator"),
              duration: 0,
            });
          } else {
            console.log("Media device error", errMessage);
            that.$notify.error({
              title: this.$t("message.Camera/Microphone error"),
              message: this.$t("message.Error while accessing camera/microphone Contact administrator"),
              duration: 0,
            });
          }
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on("recordingStarted", () => {
        this.$data.recording = true;
        if (
          this.$data.notificationHandle &&
          this.$data.notificationHandle.close
        ) {
          this.$data.notificationHandle.close();
        }
        this.$data.notificationHandle = this.$notify({
          message: this.$t("message.This video call is now being recorded"),
          type: "info",
          customClass: "rec-notification el-col-xs-15",
          duration: 4000,
        });
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("recordingStopped", () => {
        this.$data.recording = false;
        if (
          this.$data.notificationHandle &&
          this.$data.notificationHandle.close
        ) {
          this.$data.notificationHandle.close();
        }
        this.$data.notificationHandle = this.$notify({
          message: this.$t("message.Recording has been stopped"),
          type: "info",
          customClass: "rec-notification el-col-xs-15",
          duration: 4000,
        });
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("muteSpeaker", () => {
        let allParticipants = document.querySelectorAll("#remoteHolder video");
        if (allParticipants) {
          for (let i = 0; i < allParticipants.length; i++) {
            allParticipants[i].muted = "muted";
          }
        }
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("unmuteSpeaker", () => {
        let allParticipants = document.querySelectorAll("#remoteHolder video");
        if (allParticipants) {
          for (let i = 0; i < allParticipants.length; i++) {
            allParticipants[i].muted = "";
          }
        }
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("toggleVideoLayout", () => {
        console.log("calling toogle layout for socket ebvent");

        this.toggleVideoLayout(true);
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("refreshVideo", () => {
        window.location.reload();
      });

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "changeVideoParameters",
        (videoParameters) => {
          if (videoParameters) {
            let baseUrl = window.location.href.split("?")[0];
            let initParams = Object.assign(
              this.simpleMeetingsVmaatu.initParams,
              videoParameters
            );
            let queryString = "";
            for (let i in Object.keys(initParams)) {
              let key = Object.keys(initParams)[i];
              let value = initParams[key];
              queryString = queryString + key + "=" + value + "&";
            }
            queryString = queryString.substring(0, queryString.length - 1);
            window.history.replaceState(
              null,
              document.title,
              baseUrl + "?" + queryString
            );
            window.location.reload();
          }
        }
      );

      this.simpleMeetingsVmaatu.eventEmitter.on("muteEvent", (muteEvent) => {
        this.allParticipants.forEach((video) => {
          if (video.id == muteEvent.from) {
            if (muteEvent.eventType == "AUDIO_MUTED") {
              video.audioMuted = true;
            } else if (muteEvent.eventType == "AUDIO_UNMUTED") {
              video.audioMuted = false;
              //Autoplay doesn't work on MS edge
              if (this.$refs.remoteAudios && this.$refs.remoteAudios.length) {
                this.$refs.remoteAudios.forEach((audio) => {
                  if (audio.paused) {
                    audio.play();
                  }
                });
              }
            } else if (muteEvent.eventType == "VIDEO_MUTED") {
              video.videoMuted = true;
            } else if (muteEvent.eventType == "VIDEO_UNMUTED") {
              video.videoMuted = false;
            }
          }
        });
      });

      this.simpleMeetingsVmaatu.eventEmitter.on("speakEvent", (speakEvent) => {
        if (speakEvent.from) {
          this.allParticipants.forEach((participant) => {
            if (participant.id == speakEvent.from) {
              participant.speaking =
                speakEvent.eventType && speakEvent.eventType == "SPEAKING";
            }
          });

          if (speakEvent.from == this.localParticipant.id) {
            this.localParticipant.speaking =
              speakEvent.eventType && speakEvent.eventType == "SPEAKING";
          }
        }
        this.$forceUpdate();
      });

      this.simpleMeetingsVmaatu.eventEmitter.on(
        "dominantSpeaker",
        (dominantSpeaker) => {
          //Only bring the speaker to stage when screen is not being shared or when nobody is pinned to stage
          if (dominantSpeaker && !this.hasScreenShare && !this.userPinned) {
            this.setAsMainVideo(dominantSpeaker);
          }
        }
      );

      setInterval(() => {
        that.getRequiredVideoStreams();
      }, 3000);


    },
    isMyVideo(id) {
      return this.myId && this.myId == id;
    },
    paginatedParticipantsForMosaicView() {
      let that = this;
      let allParticipants = this.allParticipants;

      if (!this.hasScreenShare) {
        allParticipants = this.allParticipants.filter(
          (secondaryParticipant) => {
            return !that.mainParticipantsForActivePresence.find(
              (participant) => {
                return participant.id == secondaryParticipant.id;
              }
            );
          }
        );
      }

      let startIndex = this.pageSizeForMosaic * (this.pageNumber - 1);

      let participants = allParticipants.slice(
        startIndex,
        this.pageSizeForMosaic * this.pageNumber
      );

      return participants;
    },
    // mainVideoForMosaicView() {
    //   return this.allParticipants.find((remoteVideo) => {
    //     return remoteVideo.main;
    //   });
    // },
    getRequiredVideoStreams(useForce) {
      //If called intentionally or if participant change is detected or if video layout is changed
      if (
        useForce ||
        this.optimalVideoSubscription.noOfParticipants !=
        this.allParticipants.length ||
        this.optimalVideoSubscription.videoLayout != this.videoLayout ||
        this.optimalVideoSubscription.pageNumber != this.pageNumber
      ) {
        if (this.videoLayout == "grid") {
          this.videoResolutionType =
            this.paginatedparticipantsExceptMe.length < 2 //Needs to be changed to 5
              ? "videoHighRes"
              : "videoLowRes";

          let resolutionSwitch =
            this.currentResolution == this.videoResolutionType ? false : true;
          this.currentResolution = this.videoResolutionType;
          this.paginatedparticipantsExceptMe.forEach((participant) => {
            //If stream with selected video resolution is not ctocted
            if (
              (!participant.streams ||
                !participant.streams[this.videoResolutionType]) &&
              (!participant.waitingToConnect ||
                !participant.waitingToConnect[this.videoResolutionType])
            ) {
              if (!participant.waitingToConnect) {
                participant.waitingToConnect = {};
              }
              participant.waitingToConnect[this.videoResolutionType] = true;
              this.simpleMeetingsVmaatu.webrtcManager.connectToSFUParticipant(
                participant.id,
                this.videoResolutionType
              );
            }
          });

          if (resolutionSwitch) {
            let unwantedVideoResolution =
              this.videoResolutionType == "videoHighRes"
                ? "videoLowRes"
                : "videoHighRes";

            this.paginatedparticipantsExceptMe.forEach((_participant) => {
              if (
                _participant.streams[unwantedVideoResolution] &&
                !_participant.waitingToDisconnect[unwantedVideoResolution]
              ) {
                _participant.waitingToDisconnect[
                  unwantedVideoResolution
                ] = true;
                this.simpleMeetingsVmaatu.webrtcManager.disconnectFromSFUParticipant(
                  _participant.id,
                  unwantedVideoResolution
                );
              }
            });
          }
        } else {
          //Disconnect all high res streams
          this.paginatedparticipantsExceptMe.forEach((participant) => {
            if (participant.streams.videoHighRes) {
              this.simpleMeetingsVmaatu.webrtcManager.disconnectFromSFUParticipant(
                participant.id,
                "videoHighRes"
              );
            }
          });

          //Disconnect low res stream of main video
          if (this.mainParticipantsForActivePresence.length) {
            //If main participant is not sharing screen,
            if (!this.mainParticipantsForActivePresence[0].sharingScreen) {
              if (
                this.mainParticipantsForActivePresence[0].streams.videoLowRes
              ) {
                this.simpleMeetingsVmaatu.webrtcManager.disconnectFromSFUParticipant(
                  this.mainParticipantsForActivePresence[0].id,
                  "videoLowRes"
                );
              }

              //Connect to high res stream of main video
              if (
                !this.mainParticipantsForActivePresence[0].streams.videoHighRes
              ) {
                this.simpleMeetingsVmaatu.webrtcManager.connectToSFUParticipant(
                  this.mainParticipantsForActivePresence[0].id,
                  "videoHighRes"
                );
              }
            } else {
              if (
                this.mainParticipantsForActivePresence[0].streams.videoHighRes
              ) {
                this.simpleMeetingsVmaatu.webrtcManager.disconnectFromSFUParticipant(
                  this.mainParticipantsForActivePresence[0].id,
                  "videoHighRes"
                );
              }

              //Connect to low res stream of main video
              if (
                !this.mainParticipantsForActivePresence[0].streams.videoLowRes
              ) {
                this.simpleMeetingsVmaatu.webrtcManager.connectToSFUParticipant(
                  this.mainParticipantsForActivePresence[0].id,
                  "videoLowRes"
                );
              }
            }

            //Connect rest of participants to low res
            this.paginatedparticipantsExceptMe.forEach((participant) => {
              if (
                participant.id !=
                this.mainParticipantsForActivePresence[0].id &&
                !participant.streams.videoLowRes
              ) {
                this.simpleMeetingsVmaatu.webrtcManager.connectToSFUParticipant(
                  participant.id,
                  "videoLowRes"
                );
              }
            });
          }
        }
      }

      this.optimalVideoSubscription.noOfParticipants =
        this.allParticipants.length;
      this.optimalVideoSubscription.videoLayout = this.videoLayout;
      this.optimalVideoSubscription.pageNumber = this.pageNumber;

      //Autoplay doesn't work on MS edge
      if (this.$refs.remoteAudios && this.$refs.remoteAudios.length) {
        this.$refs.remoteAudios.forEach((audio) => {
          if (audio.paused) {
            audio.play();
          }
        });
      }
    },
    updateParticipants() {
      let participants =
        this.simpleMeetingsVmaatu.participantManager.participants;
      this.allParticipants = Object.keys(participants).map((id) => {
        participants[id].waitingToConnect = {};
        participants[id].waitingToDisconnect = {};

        return participants[id];
      });
      this.localParticipant = {
        audioMuted: this.simpleMeetingsVmaatu.webrtcManager.audioMuted,
        videoMuted: this.simpleMeetingsVmaatu.webrtcManager.videoMuted,
        id: this.simpleMeetingsVmaatu.userManager.id,
        name: this.simpleMeetingsVmaatu.userManager.name,
        streams: {
          videoHighRes:
            this.simpleMeetingsVmaatu.webrtcManager.processedLocalVideoStream ||
            this.simpleMeetingsVmaatu.webrtcManager.localVideoStream,
          screen: this.simpleMeetingsVmaatu.webrtcManager.localScreenStream,
        },
        mediaMode: "sendrecv",
        role: this.simpleMeetingsVmaatu.userManager.role,
      };
      this.$forceUpdate();
    },
    shareScreen() {
      if (!this.hasMyScreen) {
        this.simpleMeetingsVmaatu.webrtcManager.startScreenShare();
      } else {
        this.simpleMeetingsVmaatu.webrtcManager.stopScreenShare();
      }
    },
    isMobileVideo(video) {
      if (
        video.streams.videoHighRes &&
        video.streams.videoHighRes.getVideoTracks()[0].getSettings().height &&
        video.streams.videoHighRes.getVideoTracks()[0].getSettings().width
      ) {
        if (
          video.streams.videoHighRes.getVideoTracks()[0].getSettings().height <=
          video.streams.videoHighRes.getVideoTracks()[0].getSettings().width
        ) {
          return false;
        } else {
          return true;
        }
      } else if (
        video.streams.videoLowRes &&
        video.streams.videoLowRes.getVideoTracks()[0].getSettings().height &&
        video.streams.videoLowRes.getVideoTracks()[0].getSettings().width
      ) {
        if (
          video.streams.videoLowRes.getVideoTracks()[0].getSettings().height <=
          video.streams.videoLowRes.getVideoTracks()[0].getSettings().width
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    getMediaDevices(selectDefaultDevices) {
      this.videoDevices = [];
      this.audioDevices = [];
      let that = this;
      navigator.mediaDevices.enumerateDevices().then(function (sourceInfos) {
        for (var i = 0; i != sourceInfos.length; ++i) {
          var sourceInfo = sourceInfos[i];
          if (sourceInfo.kind === "videoinput") {
            that.videoDevices.push(sourceInfos[i]);
          }
          if (sourceInfo.kind === "audioinput") {
            that.audioDevices.push(sourceInfos[i]);
          }
        }

        if (selectDefaultDevices) {
          if (that.videoDevices && that.videoDevices.length > 0) {
            that.selectedVideoDevice = that.videoDevices[0];
          }
          if (that.audioDevices && that.audioDevices.length > 0) {
            that.selectedAudioDevice = that.audioDevices[0];
          }
        }
      });
    },
    async changeMedia() {
      let that = this;

      const audioSource = this.selectedAudioDevice
        ? this.selectedAudioDevice.deviceId
        : null;
      const videoSource = this.selectedVideoDevice
        ? this.selectedVideoDevice.deviceId
        : null;

      const constraints = {
        audio: { deviceId: audioSource ? { exact: audioSource } : undefined },
        video: {
          deviceId: videoSource ? { exact: videoSource } : undefined,
          width: {
            ideal: 640,
          },
          height: {
            ideal: 360,
          },
        },
      };

      let previewAudioConstraints = {
        audio: { deviceId: audioSource ? { exact: audioSource } : undefined },
        video: false,
      };
    },
    closeSlowInternetNotification() {
      if (document.getElementsByClassName("close")[0]) {
        document.getElementsByClassName("close")[0].click();
      }
    },
    openHelpPage() {
      window.open("https://support.google.com/chrome/answer/2693767", "_blank");
    },
    getParticipantName(id) {
      let participant = this.allParticipants.find((_participant) => {
        return _participant.id == id;
      });

      participant = participant || this.localParticipant;

      if (participant) {
        let name = participant.name;
        let roles = [];

        if (roles.length > 0) {
          name = `${name} (${roles.join(", ")})`;
        }

        return name;
      } else {
        return "";
      }
    },
    goToNextPage() {
      if (this.pageNumber < this.gridLayout.pageSize) this.pageNumber++;
    },
    goToNextPageOfActivePresence() {
      if (
        this.pageNumber * this.pageSizeForMosaic <=
        this.allParticipants.length - 2
      ) {
        this.pageNumber++;
      }
    },
    goToPreviousPageOfActivePresence() {
      if (this.pageNumber > 1) this.pageNumber--;
    },
    goToPreviousPage() {
      if (this.pageNumber > 1) this.pageNumber--;
    },
    async toggleMuteAudio() {
      await this.simpleMeetingsVmaatu.webrtcManager.toggleMuteAudio();
      this.$forceUpdate();
      if (
        this.simpleMeetingsVmaatu &&
        this.simpleMeetingsVmaatu.webrtcManager
      ) {
        if (this.simpleMeetingsVmaatu.webrtcManager.audioMuted) {
          this.vmaatuAudioMuted = true;
        } else {
          this.vmaatuAudioMuted = false;
        }
      }
    },
    async toggleMuteVideo() {
      await this.simpleMeetingsVmaatu.webrtcManager.toggleMuteVideo();
      this.$forceUpdate();
      if (
        this.simpleMeetingsVmaatu &&
        this.simpleMeetingsVmaatu.webrtcManager
      ) {
        if (this.simpleMeetingsVmaatu.webrtcManager.videoMuted) {
          this.vmaatuVideoMuted = true;
        } else {
          this.vmaatuVideoMuted = false;
        }
      }
    },
    toggleRecording() {
      !this.simpleMeetingsVmaatu.webrtcManager.recording
        ? this.simpleMeetingsVmaatu.webrtcManager.startRecording()
        : this.simpleMeetingsVmaatu.webrtcManager.stopRecording();
    },
    async toggleCamera() {
      let facingMode =
        this.simpleMeetingsVmaatu.webrtcManager.facingMode == "user"
          ? "environment"
          : "user";
      await this.simpleMeetingsVmaatu.webrtcManager.setFacingMode(facingMode);
    },
    refresh() {
      let that = this;
      this.destroy();
      setTimeout(() => {
        that.init();
      }, 1000);
    },
    recordingDisabled() {
      return this.simpleMeetingsVmaatu.webrtcManager
        ? this.simpleMeetingsVmaatu.webrtcManager.startRecordingInitiated
        : false;
    },
    audioMuted() {
      return (
        this.simpleMeetingsVmaatu.webrtcManager
          ? this.simpleMeetingsVmaatu.webrtcManager.audioMuted
          : false
      )
        ? true
        : false;
    },
    videoMuted() {
      return this.simpleMeetingsVmaatu.webrtcManager &&
        this.simpleMeetingsVmaatu.webrtcManager.videoMuted
        ? true
        : false;
    },
    recordingFeatureEnabled() {
      if (
        this.simpleMeetingsVmaatu.webrtcManager &&
        this.simpleMeetingsVmaatu.userManager
      )
        return (
          this.simpleMeetingsVmaatu.webrtcManager.recordingEnabled &&
          this.simpleMeetingsVmaatu.recordingControlsEnabled
        );
    },
    controlsEnabled() {
      return this.simpleMeetingsVmaatu.controlsEnabled;
    },
    getVideoLayout() {
      if (document.getElementById("remoteHolder")) {
        return (
          this.videoLayout +
          " " +
          (this.videoLayout == "grid" ? " remote-videos" : "")
        );
      }
    },
    toggleVideoLayout(selectMainVideo) {
      this.videoLayout =
        this.videoLayout == "grid" ? "active-presence" : "grid";

      //Reset page number of pagination
      this.pageNumber = 1;

      if (this.videoLayout == "active-presence") {
        //If no main participant or if arg:selectMainVideo = true
        if (!this.mainParticipantsForActivePresence.length || selectMainVideo) {
          this.mainParticipantsForActivePresence = [this.allParticipants[0]];
        }
      }
    },

    setAsMainVideo(id, pinIt) {
      if (pinIt) {
        this.userPinned = true;
      }

      //Make selected video as main video
      this.allParticipants.forEach((video) => {
        if (video.id == id) {
          this.mainParticipantsForActivePresence = [video];
        }
      });
      this.$forceUpdate();
    },
  },
  watch: {
    allParticipants: function () {
      if (this.allParticipants.length > 0) {
        this.CALL_IN_PROGRESS = true;
      }

      //Setting avatar icon class when meeting is audio only
      if (this.AUDIO_ONLY) {
        if (this.allParticipants.length > 1) {
          if (this.allParticipants.length == 2) {
            this.userAvatarClass = {
              position: "relative",
              fontSize: "18em",
              top: "0.8em",
              left: "0.3em",
            };
          } else {
            this.userAvatarClass = {
              position: "relative",
              fontSize: "18em",
              top: "0.2em",
              left: "0.3em",
            };
          }
        } else {
          this.userAvatarClass = {
            position: "relative",
            fontSize: "20em",
            top: "0.6em",
            left: "0",
          };
        }
      }
    },
  },
};
</script>

<style scoped>
/deep/ #chat-input {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

/deep/ #chat-input + .el-input-group__append {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

/deep/.el-loading-mask.small .el-loading-spinner .circular {
  width: 20px;
  height: 20px;
}

/deep/.el-loading-mask.small .el-loading-spinner .el-loading-text {
  font-size: 16px;
}

.my-video {
  transform: scale(-1, 1);
}

.media-join-section .user-id {
  margin-top: 2em;
}

.media-join-section .label {
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 2rem;
}

/deep/.el-button--text i {
  padding-right: 1em;
}

/deep/ .el-divider--horizontal {
  margin: 0px;
}

/deep/.el-input__prefix {
  display: grid;
  place-content: center;
}

.media-preview {
  display: flex;
  height: 100%;
  place-items: center;
}

.preview-video-wrapper {
  text-align: center;
  position: relative;
}

.preview-video {
  margin-top: 1px;
  width: 100%;
  border-radius: 18px;
  max-width: 100%;
  box-shadow: 0px 1px 17px -1px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 1px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 1px 17px -1px rgba(0, 0, 0, 0.75);
}

.camera-selection {
  text-align: center;
}

.media-selection {
  margin-top: -1em;
  display: flex;
}

.microphone-selection {
  text-align: center;
}

.microphone-selection,
.camera-selection {
  flex: 1;
}

.camera-off-message {
  position: absolute;
  top: 50%;
  color: #fff;
  inset-inline-end: 50%;
  transform: translateX(50%) translateY(-50%);
}

@media screen and (max-width: 460px) {
  .camera-off-message {
    position: absolute;
    top: 25%;
    color: #fff;
    inset-inline-end: 50%;
    transform: translateX(50%) translateY(-50%);
  }
}

html,
body,
#app,
.meeting-room {
  height: 100%;
  width: 100%;
  margin: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.participants {
  background-color: #303133;
  /* Black*/
}

#recording-text {
  z-index: 1;
  font-weight: 600;
  font-size: 1.2em;
  color: white;
  display: inline-block;
  padding-left: 0.5em;
}

.controls {
  position: fixed;
  bottom: 15%;
  width: 75%;
  left: 50%;
  margin-left: -37.5%;
  z-index: 2002;
}

.remote-controls {
  z-index: 2002;
}

.control-floored {
  bottom: 2%;
}

.layout-controls {
  position: fixed;
  top: 1em;
  width: 10%;
  inset-inline-end: 1em;
  z-index: 9999999;
}

.layout-buttons {
  padding: 5px;
}

.meeting-settings-controls {
  position: fixed;
  top: 1em;
  width: 10%;
  left: 1em;
  z-index: 9999999;
}

.settings-buttons {
  padding: 5px !important;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.main-content {
  position: relative;
  overflow: hidden;
}

.video-strip {
  position: fixed;
  bottom: 5px;
  left: 5px;
  z-index: 2001;
}

/deep/ .el-avatar.participant-video-avatar {
  position: absolute;
  inset-inline-end: 50%;
  transform: translateX(50%) translateY(-50%);
  bottom: 50%;
  width: 25%;
  height: unset;
  aspect-ratio: 1;
  top: 50%;
  display: grid;
  place-content: center;
  font-size: 400%;
  max-width: 200px;
}

.my-video-div /deep/ .el-avatar.participant-video-avatar {
  font-size: 4em;
}

/* Fix for avatar size in mobile when more than 3 videos are there */
/deep/ .el-avatar.participant-video-avatar-mobile {
  width: 45%;
  max-width: 60px;
}

/deep/ .el-avatar.participant-video-avatar-mobile > .el-icon-user-solid {
  font-size: 0.6em;
}

#remoteHolder {
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  height: 100%;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  width: calc(100% - 4vw);
  align-self: center;
}

.participants-tab-open #remoteHolder {
  width: 100%;
}

/* Commenting below code top move the meeting title to top */
/* .remote-videos-wrapper {
  padding-top: 20px;
} */

.remote-videos-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: width 0.3s;
  position: relative;
  /* Commented below code to fix pagination and unpin button */
  /*  z-index: -1; */
  /*To go behind side panel on mobile*/
  overflow: hidden;
}

.participants-tab-open .remote-videos-wrapper {
  padding-top: 0px;
}

/* padding-top: 20px; */
/* Changed styles and added aspect ratio to remove grey space around video */
/* #remoteHolder.grid div {
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16 / 9;
  width: 90%; //to keep a gap between videos
  border-radius: 18px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  overflow: hidden;
} */
.desktop-video {
  width: 100%;
}

/* .mobile-video {
  width: 45%;
} */
#remoteHolder > div > div > video {
  /* Commented below code to remove grey space around video */
  /*   position: absolute;
  inset-inline-end: 0;
  bottom: 0;
  top: 0;
  left: 0;
  min-height: 100%;
  min-width: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  background-size: cover;
  overflow: hidden;
  border: 1px solid #f3f2f2; */
  /* height: 100%;
  width: 100%;
  */
}

#remote-video-strip > div > div {
  height: 6em;
}

/* #remote-video-strip > div > div > video {
  max-width: 100%;
  height: 100%;
  border-radius: 4px;
} */

.button-pin.pinned {
  transform: rotate(45deg);
}

.main-stage .button-pin {
  position: absolute;
  inset-inline-end: 0.5em;
  top: 0.5em;
}

#remote-video-strip .button-pin {
  display: none;
  position: absolute;
  top: 3px;
  inset-inline-end: 50%;
  transform: translateX(50%);
  z-index: 1;
}

/* Enable pinnig only in pc and when screen in not being shared */
@media screen and (min-width: 768px) {
  #remote-video-strip:not(.sharing-screen) .remote-video-wrapper:hover .video-wrapper {
    filter: brightness(0.5);
    background: #fff;
  }

  #remote-video-strip:not(.sharing-screen) .remote-video-wrapper:hover .button-pin {
    display: block;
  }
}

/* #remoteHolder.grid.videos1 video {
   width: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
   Fliping video when there is single video fix
  transform: scale(-1, 1) translateY(-50%);
} */
#remoteHolder.grid.two-rows div {
  height: 50%;
}

#remoteHolder.grid.remote-videos.videos0 div {
  width: 100%;
  height: 100%;
}

#remoteHolder.grid.videos1 div {
  /* Comment below code because it put grey space around the video when side panel is opened */
  /* height: 100%; Fitting the video to available height to avoid cropping */

  /*vertically center alligned*/
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

/* #remoteHolder.grid.videos1 video.potrait {
  height: 100%;
} */
#remoteHolder.active-presence div.main {
  width: 100%;
  position: relative;
  margin: 0px;
  border-radius: 0px;
  cursor: auto;
}

/* #remoteHolder.active-presence #remote-video-strip > div > div {
  width: 200px;
  text-align: center;
  inset-inline-end: 0px;
  border-radius: 5px;
  outline: none;
} */
#remoteHolder #remote-video-strip {
  width: 100%;
  display: flex;
  justify-content: center;
  top: 0px;
  text-align: right;
  inset-inline-end: 0px;

  /* To come behind .el-loading-mask */
  z-index: 2000;

  /* To fix speaking participant outline*/
  margin-top: 1em;
  margin-bottom: 0.5em;
  position: relative;
}

.video-wrapper {
  background: #303133;
}

.video-wrapper.video-div video {
  height: 100%;
}

#local-holder-overlay {
  position: absolute;
}

.video-description {
  margin: 0px;
  font-size: 2vw;
}

.local-video {
  width: 100%;
}

.grid .main {
  height: calc(100% - 7em);
}

.participant-name {
  position: absolute;
  z-index: 2001;
  color: #161414;
  top: 6px;
  background: #ffffffbf;
  padding: 6px;
  inset-inline-end: 50%;
  -webkit-transform: translateX(50%);
  transform: translateX(50%);
  border-radius: 6px;
  font-size: 0.8em;
  width: fit-content;
  font-weight: 500;
  max-height: 2.5em;
}

.my-video-div .participant-name {
  font-size: 0.7rem;
  padding: 0.2rem;
  bottom: 1px;
}

.my-video-div {
  z-index: 2001;
}

/* .remote-video {
	min-width: 100%;
	min-height: 100%;
	width: auto;
	height: auto;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
} */

.remote-audio {}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  padding: 0px;
}

.el-loading-spinner i {
  color: #1e95fa !important;
}

.el-loading-spinner .el-loading-text {
  color: #1e95fa !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

/deep/.media-selection .el-dropdown {
  font-size: 1.1em;
}

.loader-container {
  position: absolute;
  bottom: 57px;
  left: 13px;
  display: flex;
  place-content: center;
  align-items: center;
  background: #5f6266;
  min-height: 25px;
  padding: 5px;
  border-radius: 5px;
}

.loader-container > div {
  border-radius: 5px;
  min-height: 5px;
  max-height: 20px;
  transition: height 0.2s;
  position: relative;
  display: inline-block;
  background: #fff;
  height: 100%;
  width: 5px;
  margin: 1px;
  -webkit-animation: load 3s ease-in-out infinite;
  animation: load 3s ease-in-out infinite;
}

.loader-container .rectangle-2 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.loader-container .rectangle-3 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.loader-container .rectangle-4 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.loader-container .rectangle-5 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.loader-container .rectangle-6 {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}

/deep/.media-join-section .el-input__inner {
  background: transparent;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  font-size: 1.5em;
}

/deep/.el-header {
  background: none;
}

/** Media queries **/
@media screen and (min-width: 980px) {
  .video-description {
    font-size: 16px;
  }
}

@media screen and (max-width: 460px) {
  #recording-text {
    font-size: 0.8em;
  }

  .rec-notification.el-col-xs-15 {
    width: 80%;
    padding: 5px;
  }

  .rec-notification .el-notification__closeBtn.el-icon-close {
    top: 9px;
  }

  .rec-notification p {
    font-size: 0.8em;
  }

  .rec-notification i.el-notification__icon {
    font-size: 16px;
  }

  .rec-notification .el-notification__group {
    margin: 0px;
  }

  /*   #remoteHolder.grid video {
    width: 100%;
    height: 50%;
  } */
  #remoteHolder.grid.two-rows video {
    width: 50%;
    height: 50%;
  }

  .controls {
    position: fixed;
    bottom: 0.5em;
    width: 75%;
    left: 50%;
    margin-left: -37.5%;
    z-index: 2002;
  }
}

/* Preview video layout for tablet */
@media (max-width: 1024px) {
  .media-preview {
    flex-direction: column;
  }

  .preview-video-wrapper {
    max-height: 40vh;
    aspect-ratio: 9/16;
    margin: auto;
    padding-top: 2em;
  }

  .preview-video {
    height: 100%;
  }

  .media-join-section {
    padding: 1em;
  }
}

@media (max-width: 575.98px) {
  .media-join-section .user-id {
    margin-top: 0em;
  }

  /deep/.media-join-section .el-input__inner {
    font-size: 1.2em;
  }

  .media-join-section .label {
    font-size: 1rem;
  }

  /* Fix for preview video resizing upon video mute and unmute in phone */
  .preview-video-wrapper {
    max-height: 30vh;
    aspect-ratio: 9/16;
    margin: auto;
    padding-top: 0;
  }

  .preview-video {
    height: 100%;
  }

  .loader-container {
    left: -70px;
  }

  .media-preview {
    flex-direction: column;
  }

  .media-preview .media-join-section {
    padding: 0 8vw 0 8vw;
    flex: 1;
    display: grid;
    place-content: center;
  }

  .microphone-selection,
  .camera-selection {
    text-align: left;
    width: 100%;
    margin-left: 0px;
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .media-selection {
    flex-direction: column;
  }
}

/** Workaround styles **/
.svg-inline--fa.fa-w-11,
.svg-inline--fa.fa-w-20 {
  width: 1.125em;
}

.rec-notification .el-notification__content {
  margin: 0px;
}

.video-div {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16 / 9;
  width: 95%;
  border-radius: 18px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  overflow: hidden;
}

.video-div.mobile-video-div {
  aspect-ratio: 9 / 16;
}

.video-div.my-video-div {
  width: 36vw;
  max-width: 300px;
  border-radius: 12px;
}

.video-div.my-video-div.mobile-video-div {
  width: 22vw;
}

#remoteHolder.active-presence #remote-video-strip .video-div {
  border-radius: 10px;
}

.active-speaker {
  outline: 2px solid #409eff !important;
  animation: ripple-active-user 0.6s linear infinite;
}

/** Animations **/
@keyframes ripple-active-user {
  0% {
    box-shadow: 0 4px 10px rgba(64, 158, 255, 0.1),
      0 0 0 0 rgba(64, 158, 255, 0.1), 0 0 0 5px rgba(64, 158, 255, 0.1),
      0 0 0 10px rgba(64, 158, 255, 0.1);
  }

  100% {
    box-shadow: 0 4px 10px rgba(64, 158, 255, 0.1),
      0 0 0 5px rgba(64, 158, 255, 0.1), 0 0 0 10px rgba(64, 158, 255, 0.1),
      0 0 0 20px rgba(64, 158, 255, 0);
  }
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s step-end infinite;
  -webkit-animation: blink 1s step-end infinite;
}

.preview-video-disabled {
  background: black;
  border-radius: 18px;
  height: 21vh;
  width: 100%;
}
</style>
<style scoped>
/deep/ .el-loading-spinner {
  font-size: 2em;
}

/deep/ .el-loading-text {
  font-size: 20px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ #chatmessages .el-card__body {
  padding: 6px;
  font-size: 0.8em;
  word-wrap: break-word;
}

/deep/ .el-badge__content.is-fixed {
  top: 4px;
  inset-inline-end: 15px;
}

.mymessage {
  text-align: right;
}

.mymessage-card {
  background: #409eff;
  color: #fff;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 0px !important;
}

/deep/ .no-internet {
  z-index: 2002 !important;
}

@keyframes alert {
  from {
    box-shadow: red 0px 0px 50px 0px inset;
  }

  to {
    box-shadow: #ff0000a1 0px 0px 160px 30px inset;
  }
}

.remote-alert {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  text-align: center;
  -webkit-box-align: center;
  align-items: center;
  animation-name: alert;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  display: flex;
  justify-content: center;
  align-items: normal;
}

.landscape-controls {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center !important;
}

.el-row.landscape-controls .refresh-button {
  position: unset !important;
}

/deep/ .pinch-zoom-wrapper {
  background-color: unset !important;
  width: 100%;
}

/* Dark mode */

.dark main,
.dark .el-input__inner,
.dark .el-input-group__append {
  background: #303133;
}

.dark :not(.virtual-background-selection) > .el-button:not(:hover, .el-button--primary, .el-button--danger),
.dark .el-card:not(.mymessage-card),
.dark .el-dropdown-menu {
  background: #303133;
  color: #e4e7ed;
  border-color: #606266;
}

.dark .el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #303133;
}

.dark .brand-logo {
  filter: invert(0.5);
}

.dark .brand-logo-mini {
  filter: invert(0.5);
}

.dark .el-dropdown-menu__item:not(.is-disabled):hover,
.dark .el-dropdown-menu__item:focus,
.dark .el-button:hover {
  background-color: #ecf5ff2e;
}

.dark .el-dropdown-menu__item,
.dark .el-input__inner {
  color: #e4e7ed;
}

.dark .el-card__header {
  border-color: #606266;
}

.dark .el-popover {
  background-color: #414244;
  border: none;
}

.dark .el-popover > div .el-button {
  background: none !important;
  border: none;
}

.dark .el-popper[x-placement^="top"] .popper__arrow,
.dark .el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #414244;
}</style>
